/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bold_Sage_Horse_JumpInputs */

const en_bold_sage_horse_jump = /** @type {(inputs: Bold_Sage_Horse_JumpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filters`)
};

const de_bold_sage_horse_jump = /** @type {(inputs: Bold_Sage_Horse_JumpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter`)
};

/**
* | output |
* | --- |
* | "Filters" |
*
* @param {Bold_Sage_Horse_JumpInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const bold_sage_horse_jump = /** @type {((inputs?: Bold_Sage_Horse_JumpInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bold_Sage_Horse_JumpInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_bold_sage_horse_jump(inputs)
	return de_bold_sage_horse_jump(inputs)
});